import React, {useEffect, useState} from 'react';
import {setSelectedModelPart, configuratorState, setSelectedStructure,activateWall,setWallStructure, setSelectedMaterial,setCurrentModelMaterialSpecifications, setFinish} from "../../../../state";
import {useSnapshot} from "valtio";
import Dropdown from '../../Dropdown';
import Button from '../Button';
import { ListAcordion } from '../../ListAcordion';
/*
 navigator for separate parts of the product - activates relevant material set
*/
const ModelPartsDropdown = () => {
  const [expanded, setExpanded] = useState(false);
  const handleChange = (panel) => (isExpanded) => {
      console.log(panel)
    setExpanded(isExpanded ? panel===expanded?false: panel :  false);
  };
  const[toggle, setToggle] = useState([false,false,false,false])
  const handleClick = (id) => {
    const temp = [false,false,false,false];
    temp[id] = true;
    setToggle(temp);
}
  const materials = [
    {name:"Timber", category:true, children:[{name:"vertical", value:"Vert-Timber", info:"H-Series Wooden Panels", finish:"Forest Panel Bare"},{name:"horizontal", value:"Horiz-Timber",info:"H-Series Wooden Panels",finish:"Forest Panel Bare"},{name:"TGV", value:"TGV",info:"H-Series Wooden Panels",finish:"Forest Panel Bare"}]},
    {name:"Toughened Glass", category:false, value:"Glass"},
    {name:"ZedPanel Mesh", category:false, value:"Zed", info:"H-Series Zed Panels",finish:"Black"},
    {name:"Steel", category:true,children:[{name:"steel",value:"STL", info:"H-Series Steel Panels",finish:"Anthracite Grey"},{name:"freestyle", value:"Freestyle-STL", info:"H-Series Freestyle Steel Panels",finish:"Anthracite Grey"}]},
  ]
  const {activeWall,partSelected,selectedMaterialGroup,wallConfigStates} = useSnapshot(configuratorState);
  
  useEffect(()=>{
    setToggle([false,false,false,false]);
  },[activeWall])
  const selectActive = (node) => {
    node.info?setSelectedModelPart(node.info):null;
    setSelectedStructure(node.value);
    activateWall(activeWall);
    setWallStructure(activeWall,node.value);

    if(!wallConfigStates[activeWall].finish){
      let found = false;
      for(const wall in wallConfigStates){
        if(wallConfigStates[wall].structure === node.value ||
          (wallConfigStates[wall].structure === "Vert-Timber" || wallConfigStates[wall].structure === "Horiz-Timber" || wallConfigStates[wall].structure === "TGV") && (node.value === "Vert-Timber" || node.value === "Horiz-Timber" || node.value === "TGV"))
          {
          setSelectedMaterial(wallConfigStates[wall].finish)
          setCurrentModelMaterialSpecifications(partSelected, [selectedMaterialGroup, wallConfigStates[wall].finish]);
          setFinish(activeWall,wallConfigStates[wall].finish)
          found = true;
          break;
        }
      }

      if(!found){
        setSelectedMaterial(node.finish)
        setCurrentModelMaterialSpecifications(partSelected, [selectedMaterialGroup, node.finish]);
        setFinish(activeWall,node.finish)
      }
    }


  }
    
  return (
   <>
        {materials.map((value, index) => {
          return (
                  value.category?
                  <ListAcordion
                  key={index}
                  active= {value.children.some((el)=>el.value === wallConfigStates[activeWall].structure)}
                  handleClick={()=>value.children?handleClick(index):null}
                    primary={false} 
                    child={true}
                    expandable={true}
                    label = {value.name}
                    expanded={expanded===`panel${index}`}
                    toggle={()=>handleChange(`panel${index}`)}
                    >

                    <div className='horizontal-options-left'>
                        {value.children.map((node, i)=>{
                          return(
                            <Button id={node.name} key={i}  image ={true} value={node.value} label = {node.name} primary = {false} large ={false} leftAlign={true}  onClick={() => selectActive(node)}/>
                            )
                          })
                        }</div>
                    </ListAcordion>
                    :
                    <Button key={index} large={true} primary={false} value={value.value} indexNo={index} label={value.name} onClick={() =>{selectActive(value); setExpanded("")}}/> )
        })}
    </>
  )
};

export default ModelPartsDropdown;